module.exports = __webpack_public_path__ + "img/grey_001.998f742b.png";